import { type Deliverable, type DeliverableDraft, type DeliverableDraftUpdate } from "@/schema/deliverable"

import { ApiContext, apiContextBlobFetch, apiContextFetch } from "@/hooks/api/base"

export function fetchDeliverableThumbnail(context: ApiContext, id: string) {
  return apiContextBlobFetch(context, `deliverables/${id}/preview.png`)
}

export function fetchDeliverable(context: ApiContext, id: string): Promise<Deliverable> {
  return apiContextFetch<Deliverable>(context, `deliverables/${id}`)
}

export async function downloadDeliverablePdf(context: ApiContext, id: string, label: string) {
  const blob = await apiContextBlobFetch(context, `deliverables/${id}/download`)
  const filename = `${label.replace(/[\\/:*?"<>|]/g, "-")}.pdf`
  return { blob, filename }
}

export function fetchDeliverableDraft(context: ApiContext, id: string): Promise<DeliverableDraft> {
  return apiContextFetch<DeliverableDraft>(context, `deliverables/${id}/draft`)
}

export function updateDeliverableDraft(
  context: ApiContext,
  id: string,
  draft: DeliverableDraftUpdate
): Promise<Deliverable> {
  return apiContextFetch<Deliverable>(context, `deliverables/${id}/draft`, {
    method: "PUT",
    body: JSON.stringify(draft),
  })
}

export function publishDeliverable(context: ApiContext, id: string): Promise<Deliverable> {
  return apiContextFetch<Deliverable>(context, `deliverables/${id}/publication`, { method: "POST" })
}

export interface PlanningProfileVariableChange {
  path: string
  operation: "set"
  value: number
}

export function updatePlanningProfileVariables(
  context: ApiContext,
  planningProfileId: string,
  changes: PlanningProfileVariableChange[],
  deliverableId: string
) {
  return apiContextFetch<void>(context, `planning_profiles/${encodeURIComponent(planningProfileId)}`, {
    method: "PATCH",
    body: JSON.stringify({ planning_profile: { changes, deliverable_id: deliverableId } }),
  })
}
